import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-68" data-mp="1o3x1pk7r0m0y">
      <div className="max-w-2xl mx-auto bg-white border border-gold/50 p-4 sm:p-7 rounded-xl text-center shadow-sm" data-id="element-69" data-mp="1o3dnoel7yhs7">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-gold-dark uppercase tracking-widest mb-2" data-id="element-70" data-mp="22128jmfadox9">
          Il Tuo Acquisto è Protetto al 100%
        </p>
        <div className="w-12 h-12 mx-auto bg-navy/5 rounded-full flex items-center justify-center mb-2 border border-navy/15" data-id="element-71" data-mp="19fac8poeqdw0">
          <ShieldCheckIcon className="w-6 h-6 text-navy" data-id="element-72" data-mp="14dtg17gvbflr" />
        </div>
        <h3 className="text-base sm:text-2xl font-heading font-extrabold text-navy mb-2 leading-tight" data-id="element-73" data-mp="1j654qbs8y9pw">
          🛡️ Garanzia Soddisfatti o Rimborsati di 14 Giorni
        </h3>
        <p className="text-[12.5px] sm:text-base text-anthracite leading-relaxed mb-1.5" data-id="element-74" data-mp="qn7x5irez5nv">
          Il tuo acquisto è completamente senza rischi. Hai 14 giorni per
          esplorare tutti i moduli, utilizzare i programmi, gli allenamenti, le
          valutazioni, le pianificazioni e gli strumenti professionali inclusi in
          RUNNING COACH PRO™.
        </p>
        <p className="text-[12.5px] sm:text-base text-anthracite leading-relaxed" data-id="element-75" data-mp="ypl2pknk798a">
          Se per qualsiasi motivo non sarai completamente soddisfatto, ti basterà
          contattarci entro 14 giorni e riceverai il rimborso completo.{' '}
          <span className="font-bold text-navy" data-id="element-76" data-mp="628dt3txepbt">
            Nessun rischio. Nessuna domanda.
          </span>
        </p>
      </div>
    </section>;
}